export const NODE_NAME = 'ordered_list';
export const ORDERED_LIST_REGEX = /^(\d+)\.\s$/;
